import webApi from '../../WebApi/WebApi';

//Stories list
export const getAllStoriesList = async () => {
    return await webApi.get(`/admin/stories`);
}